module.exports = __webpack_public_path__ + "static/assets/205c96e2241f566e4aa767b720b36167.png";